"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "osiglia": {
    "a5e4b71e": [{
      "hkey": "bed85863",
      "slug": "borgo-ripa",
      "name": "Borgo-Ripa",
      "primary": true,
      "skipSearch": false
    }],
    "borgo": [{
      "hkey": "bed85863",
      "slug": "borgo-ripa",
      "name": "Borgo-Ripa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1692a46a": [{
      "hkey": "bed85863",
      "slug": "borgo-ripa",
      "name": "Borgo-Ripa",
      "primary": true,
      "skipSearch": false
    }],
    "ripa": [{
      "hkey": "bed85863",
      "slug": "borgo-ripa",
      "name": "Borgo-Ripa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "osiglia"
    }],
    "b0636cb2": [{
      "hkey": "24a33afe",
      "slug": "rossi-baltera",
      "name": "Rossi-Baltera",
      "primary": true,
      "skipSearch": false
    }],
    "rossi": [{
      "hkey": "24a33afe",
      "slug": "rossi-baltera",
      "name": "Rossi-Baltera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;